module.exports = __webpack_public_path__ + "video/200_KMSAT45_2022_Welcome.ae6aa6df.vtt";